import * as React from "react";

function SvgAdLearnOpenPlatform(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -2 35 38.8"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        fill="#BDDCE2"
        d="M2.9 32.9V11.3H1.7c-.8-.1-1.4.3-1.7 1.1v23.4h22.7c.9 0 1.5-.6 1.6-1.6v-1.3H2.9z"
      />
      <path
        fill="#4B575E"
        d="M9.6 2.9H8.5c-3 .2-5.6 2.9-5.6 5.9v24.1h21.9c.3 0 .6 0 .9-.1 3.1-.5 5.3-3 5.3-6.1V2.9H9.6zm3.5 19.6c-.3.1-.6 0-.8-.4-.2-.5-.4-.9-.5-1.4-.1-.3-.3-.5-.6-.5H8.1c-.3 0-.4.1-.5.4-.2.5-.3 1-.5 1.4-.2.4-.5.6-.8.4-.3-.1-.4-.3-.3-.7l3-8.1c.1-.4.3-.6.7-.6.5 0 .7.2.9.7.4 1.2.9 2.4 1.3 3.7.5 1.4 1 2.8 1.5 4.1 0 .1.1.2.1.3 0 .3-.1.6-.4.7zm7.4-2.2c-.5 1.8-2 2.4-3.6 2.3-2-.2-2.9-1.6-3-3.4-.1-1.1-.1-2.3.1-3.4.2-2 1.8-3.1 3.7-2.9 1.7.2 2.8 1.4 3 3.2.1.6.1 1.1.1 1.6-.1.9-.1 1.8-.3 2.6zm5.3-1.7h-2.2c-.5 0-.5 0-.5.5v2.6c0 .2 0 .3-.1.5-.1.3-.3.4-.6.4s-.5-.2-.5-.5V21v-3.2-4c0-.6.1-.8.8-.8 1.1 0 2.1 0 3.2.1 1.5.1 2.5 1.2 2.5 2.8 0 1.5-1 2.6-2.6 2.7z"
      />
      <path
        fill="#EA6125"
        d="M33.8.3c0-.2-.1-.3-.3-.3H11.1c-.8.1-1.3.6-1.4 1.3v1.6H31v21.6h1.1c1.3 0 1.8-.6 1.8-1.8V2.9.6c-.1-.1-.1-.2-.1-.3z"
      />
      <path
        fill="#4B575E"
        d="M18.2 14.2c-1-.5-2.6-.3-3.1 1.5-.1.7-.1 1.4-.1 2 0 .5 0 1.1.1 1.6.1 1.1.7 1.9 1.6 2.1 1.4.3 2.4-.3 2.7-1.7.3-1.3.2-2.6 0-3.9-.2-.7-.5-1.3-1.2-1.6zM9.9 15.1c0-.1 0-.2-.2-.2l-.1.1c-.5 1.3-.9 2.6-1.4 3.9-.1.3 0 .3.2.3h2.4c.3 0 .4-.1.3-.4-.4-1.3-.8-2.5-1.2-3.7zM25.8 14.2c-.8-.1-1.6 0-2.4-.1-.2 0-.3.1-.3.3v2.8c0 .2.1.4.3.4.8 0 1.5.1 2.3 0 .9-.1 1.4-.7 1.4-1.6.2-1.1-.4-1.7-1.3-1.8z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgAdLearnOpenPlatform);
